var FactoryMultiPDFs=0;
function MultiPDFs()
{
    FactoryMultiPDFs++;
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

var KeyLogErs = 0;

$.extend(MultiPDFs.prototype,{
    el:null,
    $el:null,
    template:'<div class="multiimages-drop-zone"> <label > <span><i class="zmdi zmdi-upload"></i> '+window.LANGUAGE['multi.upload-drop-files']+' (PDF\'s)</span> <ul class="images"></ul></label> <input type="file" multiple accept="application/pdf"> </div>',
    content:null,
    input:null,
    images:null,
    fieldName:'pdfs',
    meta:{},
    langs:[],
    currentLang:'',
    init:function(element,fieldName) {
        this.el=element;
        this.$el=$(this.el);
        this.fieldName=fieldName;

        //detect languages
        var langs = [];
        var defLang = "";
        $(".tab-nav [data-language]").each(function(){
            langs.push($(this).attr("data-language"));
            if($(this).hasClass("active")) {
                defLang = $(this).attr("data-language");
            }
        });
        this.langs = langs;
        this.currentLang = defLang.length? defLang: this.langs[0];

        console.log("found langs",this.langs);
        console.log("current lang",this.currentLang);
        this.changeLocale(this.currentLang);
        var self =this;
        $("body").on("click","[data-language]",function() {
            self.changeLocale($(this).attr("data-language"));
        });

        this.content=$(this.template);
        this.images=this.content.find("ul.images");
        this.$el.append(this.content);
        this.$el.find(".images").sortable({
            containerSelector: 'ul',
            itemSelector: 'li',
            handle:'.drag-wrap span'
        });
        this.input=this.content.find("input");
        this.input.attr("id","MultiPDFs_"+FactoryMultiPDFs);
        this.content.find("label").attr("for","MultiPDFs_"+FactoryMultiPDFs);

        this.attachDropEvents();
        this.input[0].style.display='none';
        this.grabImages();
    },
    changeLocale:function(slang,$el) {
        if(_.isUndefined($el)) {
            $el = this.$el;
        }
        this.currentLang = slang;
        for(var i in this.langs) {
            var lang = this.langs[i];
            $el.find(".show-lang-"+lang).hide();
        }
        $el.find(".show-lang-"+slang).show();
    },
    grabImages:function()
    {
        var imgs=this.$el.find("span.slide-self");
        console.log('bua',imgs);
        for(var i=0;i<imgs.length;i++)
        {
            var img = $(imgs[i]);
            var meta=JSON.parse("{}");
            if(!_.isUndefined(img.attr("data-meta")))
                _.extend(meta,JSON.parse(img.attr("data-meta")));
            console.log('AAAA',meta);
            this.createCropper(null,_.clone(meta));
            img.remove();

        }
    },
    attachDropEvents:function() {
        this.content[0].addEventListener('dragover', this.handleDragOver.bind(this));
        this.content[0].addEventListener('dragleave', this.handleDragLeave.bind(this));
        this.content[0].addEventListener('drop', this.handleDrop.bind(this));
        this.input[0].addEventListener('change', this.handleFileSelect.bind(this));
    },
    handleDragOver: function (e) {
        e.preventDefault();
        if(!this.$el.hasClass("hover-drag"))
            this.$el.addClass("hover-drag");
    },
    handleDragLeave: function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
    },
    handleDrop:function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
        this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
    },
    handleFileSelect:function(e) {
        this.handleFileItems(e.target.files);
    },
    handleFileItems:function(items) {
        var l = items.length;
        for (var i=0; i<l; i++) {
          this.handleItem(items[i]);
        }
    },
    handleItem:function(item) {

        // get file from item
        var file = item;
        if (item.getAsFile && item.kind =='file') {
            file = item.getAsFile();
        }

        this.handleFile(file);
    },
    handleFile: function(file) {
        this.$el.closest('form').attr('data-dirty','true');
        this.createCropper(file);
    },
    createCropper: function(file, meta) {
        // create container element for cropper
        var Type=(file && file.type)?file.type.split("/"):"";
        var self = this;
        if(file!=null && file.type!="application/pdf") {
            return;
        }


        /*var lmeta = {};
        if(meta) {
            lmeta.media_id = meta.media_id;
            lmeta.title = meta.title? JSON.parse(JSON.stringify(meta.title)):{};
            lmeta.description = meta.description?JSON.parse(JSON.stringify(meta.description)):{};
        }*/
        if(!meta) {
            meta = {
                origname:file.name
            };
        }
        var htmlCropper = '<li><div class="row flex-row"><div class="col-sm-1 drag-wrap"><span></span></div><div class="col-sm-3 cropper"><iframe /></div><div class="col-sm-7"><h5 class="text-left">'+meta.origname+'</h5>';
        var used = [];

        for(var ie  in this.langs) {
            var lang = this.langs[ie];
            if(used.indexOf(lang)!==-1) {
                continue;
            }
            used.push(lang);
            htmlCropper += '<div class="show-lang-'+lang+' text-show-place">' +
                '<div class="fg-line m-t-10">' +
                '<input name="'+this.fieldName+'['+KeyLogErs+'][origname]" type="hidden" value="'+meta.origname+'"/>' +
                '<input class="form-control" data-key="action" name="'+this.fieldName+'['+KeyLogErs+'][title]['+lang+']" data-lang="'+lang+'" value="'+((meta && meta.title && meta.title[lang]) ?  meta.title[lang] : file.name)+'" placeholder="'+LANGUAGE["events.pdfs.title"]+'"/></div> <div class="fg-line m-t-15">' +
                '<textarea data-no-summernote="true" rows="3" name="'+this.fieldName+'['+KeyLogErs+'][description]['+lang+']" class="form-control" data-key="description" data-lang="'+lang+'" placeholder="'+LANGUAGE['intro.description']+'">'+((meta && meta.description && meta.description[lang]) ?  meta.description[lang] : '')+'</textarea>' +
                '</div>' +
                '</div>';
        }
        htmlCropper += '</div></div><button class="drop-it-button btn btn-danger"><i class="fa fa-trash"></i></button></li>';

        var cropper = $(
            htmlCropper
            );
        cropper.on("click",function(e){ e.preventDefault(); return false;});
        cropper.on("click mousedown, mouseup, mousemove",".cropper",function(e){ e.preventDefault(); return false;});

        this.changeLocale(this.currentLang,cropper);

        cropper.append('<input type="hidden" name="'+this.fieldName+'['+KeyLogErs+'][file]"  data-type="file-place"/>');
        cropper.append('<input type="hidden" name="'+this.fieldName+'['+KeyLogErs+'][url]" value="'+(meta && meta.url ? meta.url : '')+'"/>');
        this.images.append(cropper);
        if(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            var obj_url = window.URL.createObjectURL(file);
            cropper.find("iframe")[0].src = obj_url;
            window.URL.revokeObjectURL(obj_url);
            reader.onload = function () {
                cropper.find("[data-type=file-place]")[0].value = reader.result;
                console.log(reader.result);
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };


        }else{
            cropper.find("iframe")[0].src = meta.url;
        }
        /*cropper.find(".text-show-place input, .text-show-place textarea").on("keyup",function(){
            var val = $(this).val();
            var key = $(this).attr("data-key");
            var lang = $(this).attr("data-lang");
            if(!slimlocal.data.meta[key]) {
                slimlocal.data.meta[key] = {};
            }
            slimlocal.data.meta[key][lang] = val;
            slimlocal._save();
            console.log(JSON.stringify(slimlocal.data));
        })*/

        this.content.find("ul.images").addClass("active");
        cropper.find("button").on("click", function(e){
            e.preventDefault();
            cropper.remove();
            return false;
        }.bind(this));
        KeyLogErs++;

    }
});

$(function(){
    $(".MultiPDFs").each(function(i,item){
        if(item.multi)
            return;
            item.multi = new MultiPDFs(item, $(item).attr("data-field"));
    });
});

function OnSlimUploadSetDirty(f,i) {
    $('form').attr('data-dirty','true');
    return true;
}